var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block--small"},[_c('h2',[_vm._v(_vm._s(_vm.$t("page_not_found")))]),_c('p',[_c('router-link',{staticClass:"button--cta",attrs:{"to":{ name: 'sign-in' }}},[_vm._v(" "+_vm._s(_vm.$t("navigation.go_back"))+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }